import React from "react";
import { EvidenceDossiersPanel } from "@/components/authority/KarateAuthorityDocumentsPanels.jsx";

export function DocumentsPreuvesDossiersPage() {
  return (
    <div data-testid="page-admin-documents-preuves-dossiers">
      <EvidenceDossiersPanel testId="documents-preuves-dossiers-panel" />
    </div>
  );
}
